import { lazy } from 'react';
// ----------------------------------------------------------------------

const MembersRealtionsPage = lazy(() => import('../pages/MembersRealtions.page'));
const AddMemberPage = lazy(() => import('../pages/AddMember.page'));
const ViewMemberPage = lazy(() => import('../pages/ViewMember.page'));
const EditMemberPage = lazy(() => import('../pages/EditMemberpage'));
const ComplaintsAndMsg = lazy(() => import('../pages/complaints-and-messages/ComplaintsAndMsg.pag'));
const AddComplaintPage = lazy(() => import('../pages/AddComplaint.page'));
const MembersCommunicationPage = lazy(() => import('../pages/MemberCommunication.page'));
const ListMessage = lazy(() => import('../pages/ListMessage.page'));
const AddMessagePage = lazy(() => import('../pages/AddMessage.page'));
const MarketingPage = lazy(() => import('../pages/Marketing.page'));
const ArchivePage = lazy(() => import('../pages/Archive.page'));

// ----------------------------------------------------------------------

const MembersRealtionsRoutes = [
    {
        path: 'members',
        children: [
            { element: <MembersRealtionsPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: 'add-member',
                element: <AddMemberPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'view-member/:id',
                element: <ViewMemberPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'edit-member/:id',
                element: <EditMemberPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'complaints-and-messages',
                children: [
                    {
                        element: <ComplaintsAndMsg />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add',
                        element: <AddComplaintPage />,
                        layout: 'default',
                        isAuthReq: true,
                    },
                ],
            },
            {
                path: 'member-communication',
                children: [
                    {
                        element: <MembersCommunicationPage />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add-message',
                        children: [
                            { element: <AddMessagePage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <AddMessagePage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                    {
                        path: 'list-message',
                        children: [
                            { element: <ListMessage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <ListMessage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'archive',
                element: <ArchivePage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
    {
        path: 'marketing',
        element: <MarketingPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { MembersRealtionsRoutes };
